import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BusIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 1c2.433 0 4.748.362 6.94 1.086A3 3 0 0121 4.934v.53l2.555 1.704A1 1 0 0124 8v3a1 1 0 01-2 0V8.535l-1-.667V18a2 2 0 01-.999 1.732L20 21a2 2 0 01-1.85 1.995L18 23h-1a2 2 0 01-1.995-1.85L15 21v-1H9v1a2 2 0 01-1.85 1.995L7 23H6a2 2 0 01-1.995-1.85L4 21v-1.268A2 2 0 013 18V7.868l-1 .667V11a1 1 0 01-1.993.117L0 11V8a1 1 0 01.346-.757l.1-.075L3 5.464v-.53a3 3 0 012.06-2.848C7.251 1.362 9.566 1 12 1zM7 20H6v1h1v-1zm11 0h-1v1h1v-1zm1-5.5H5V18h14v-3.5zM12 3c-2.223 0-4.326.329-6.314.985a1 1 0 00-.686.95V12.5h14V4.934a1 1 0 00-.686-.95C16.326 3.33 14.224 3 12 3z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
BusIcon.isCarinaIcon = true;
export default BusIcon;
